module.exports = __webpack_public_path__ + "img/blue_bay_spare_302.781d8f45.jpeg";